/**
 * Когда была встреча — для дат в протоколе: «до пятницы» модель переводит в число
 * только от дня встречи (bit-llm-summarize/meeting_date.py). Неизвестно — null, и
 * сервис пишет в промпт «дата неизвестна»: уверенно неверная дата хуже никакой.
 */

const MSK_OFFSET_MS = 3 * 60 * 60 * 1000;

/** «YYYY-MM-DD» по Москве — день, когда только день и известен. */
function mskDate(iso) {
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return null;
  return new Date(t + MSK_OFFSET_MS).toISOString().slice(0, 10);
}

/**
 * Запись Истории → начало встречи.
 * `meta.meeting_at` пишут бот и «Записать сейчас» (с 08.10.2026). У прежних записей бота
 * его нет; запись создаётся сразу после обработки встречи — берём день без времени
 * (встреча, закончившаяся после полуночи, получит следующий день). Загруженный файл
 * записывается в Историю в момент загрузки, а не встречи, — даты нет.
 */
export function historyMeetingAt(item) {
  const meta = item?.meta || {};
  if (meta.meeting_at) return meta.meeting_at;
  if (meta.source === 'meetbot' && item.created_at) return mskDate(item.created_at);
  return null;
}

/**
 * Начало live-записи, когда момент старта не сохранён (вкладка из версии до 08.10):
 * «сейчас» минус длина записанного. Паузы не учитываются — это запасной путь.
 */
export function streamingStartedAt(finals, now = new Date()) {
  const end = finals?.length ? finals[finals.length - 1]?.end : null;
  if (!Number.isFinite(end)) return null;
  return new Date(now.getTime() - end * 1000).toISOString();
}
